import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Close } from "components/icons/Close";

// TODO: REVISAR E ADICIONAR STYLESHEET!
import Styles from "components/alerts/Alert.module.scss";
import { UiActions } from "state/actions/UiActions";

class Alert extends Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { props } = this;

    let _cls = [Styles["alert"]];

    if (props.type) _cls.push(Styles[props.type]);

    return (
      <div className={classnames(_cls)}>
        <div className={Styles["alert__data"]}>
          <p>{props.message}</p>
        </div>
        <button className={Styles["alert__button"]}
                onClick={this.removeAlert(props.messageId)}>
          <Close fill={"rgba(0, 0, 0, .25)"} size={"100%"}/>
        </button>
      </div>
    );
  }

  // --------------------------------------------------------------------

  // TODO: REMOVER ALERTA!!!
  removeAlert = (alertId) => {
    return () => {
      this.props.removeAlert(alertId);
    };
  };
}

// ----------------------------------------------------------------------

Alert.defaultProps = {
  type: ""
};

Alert.propTypes = {
  messageId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.string
};

// ----------------------------------------------------------------------

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  removeAlert: (alertId) => {
    dispatch(UiActions.alertRemove(alertId))
  }
});

Alert = connect(mapStateToProps, mapDispatchToProps)(Alert);

export {
  Alert
};
